import { Panel } from 'primereact/panel';
import { SelectButton } from 'primereact/selectbutton';
import { Tooltip } from 'primereact/tooltip';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { IconData } from '../../../components/layout/leftDrawerEmojis/type';
import { MANAGERROLE } from '../../../constants';
import { setUserActiveCount } from '../../../pages/login/authSlice';
import IconProvider from '../../../utils/IconProvider';
import { MoodType } from '../../../utils/typeConstants';
import {
    MoodMeterRequest,
    useGetMoodmeterCountUsersGroupMoodQuery,
    usePostMoodmeterSubmitMoodMeterMutation,
} from '../MoodMeterSlice';
import Emoticon from '../emoticon/Emoticon';
import './Emojis.css';

type ManagerOptions = {
    value: string;
    tooltip: string;
};

const managerOptions: ManagerOptions[] = [
    { value: 'ORGANIZATION', tooltip: 'Organization' },
    { value: 'TEAM', tooltip: 'Team' },
];
const MoodIcons: IconData[] = [
    {
        label: 'Happy',
        name: MoodType.Happy,
        badgeContent: 0,
        iconElement: <IconProvider acrn="HAPPY" />,
    },
    {
        label: 'Tired',
        name: MoodType.Tired,
        badgeContent: 0,
        iconElement: <IconProvider acrn="TIRED" />,
    },
    {
        label: 'Confused',
        name: MoodType.Confused,
        badgeContent: 0,
        iconElement: <IconProvider acrn="CONFUSED" />,
    },
    {
        label: 'Question',
        name: MoodType.Question,
        badgeContent: 0,
        iconElement: <IconProvider acrn="QUESTION" />,
    },
    {
        label: "Don't Feel Well",
        name: MoodType.DontFeelWell,
        badgeContent: 0,
        iconElement: <IconProvider acrn="DONTFEELWELL" />,
    },
    {
        label: 'Upset',
        name: MoodType.Upset,
        badgeContent: 0,
        iconElement: <IconProvider acrn="UPSET" />,
    },
];

export type EmojisProps = {
    empId: string;
    role: string;
    supervisorId: string | null | undefined;
    moodType: string | undefined;
    onMoodTypeChange: (moodType: string) => void;
    onClosePanel: () => void;
};

const Emojis = ({ empId, role, supervisorId, onClosePanel, moodType, onMoodTypeChange }: EmojisProps) => {
    const dispatch = useDispatch();
    const [managerFilter, setManagerFilter] = useState<string>(managerOptions[1].value);
    const [SubmitMoodMeterRequest] = usePostMoodmeterSubmitMoodMeterMutation();

    const getFilterOption = () => {
        return managerFilter === 'ORGANIZATION' ? 'org' : 'team';
    };

    const { data: countStatusEmojic } = useGetMoodmeterCountUsersGroupMoodQuery(
        { supervisorNumber: empId, filter: getFilterOption() },
        { skip: !empId }
    );

    const handleClickEmoticon = (moodType: string) => {
        onMoodTypeChange(moodType);
        const payload: MoodMeterRequest = {
            oracleId: empId,
            supervisorId,
            moodType,
        };

        SubmitModMeter(payload);
    };

    const SubmitModMeter = (payload: MoodMeterRequest) => {
        SubmitMoodMeterRequest({ moodMeterRequest: payload })
            .unwrap()
            .then((res: any) => {
                if (res.data) {
                    dispatch(setUserActiveCount(1));
                    toast.success('Mood Submitted');
                } else {
                    toast.error('Failed');
                }
            })
            .catch((err: any) => {
                console.log(err);
            });
    };

    const getBadgeContent = (emoji: string) => {
        return countStatusEmojic?.data?.find((data) => data.mood_type === emoji)?.count ?? '';
    };

    const justifyTemplate = (option: ManagerOptions) => {
        return (
            <div className="managerFilterButton" data-pr-tooltip={option.tooltip}>
                <IconProvider acrn={option.value} iconHeight="20px" />
            </div>
        );
    };

    return (
        <Panel className="amojis-panel">
            <div className="containerButton">
                {React.Children.toArray(
                    MoodIcons.map((icon: IconData, index: number) => (
                        <Emoticon
                            empId={empId}
                            indexIcon={index}
                            data={{
                                label: icon.label,
                                name: icon.name,
                                badgeContent: getBadgeContent(icon.name),
                                iconElement: icon.iconElement,
                            }}
                            onClickEmoticon={handleClickEmoticon}
                            isActive={moodType === icon.name}
                            managerdisplay={getFilterOption()}
                        />
                    ))
                )}
            </div>

            {role === MANAGERROLE ? (
                <div className="managerFilter">
                    <div className="flex mb-2 gap-2 justify-content-end">
                        <Tooltip target=".managerFilterButton" position="right" />
                        <SelectButton
                            value={managerFilter}
                            onChange={(e: any) => {
                                setManagerFilter(e.value);
                            }}
                            style={{ width: '100px' }}
                            itemTemplate={justifyTemplate}
                            optionLabel="value"
                            options={managerOptions}
                            className="managerFilterButton"
                        />
                    </div>
                </div>
            ) : (
                <div />
            )}
            <button
                aria-label="close emojis panel"
                data-tooltip-content="Close Emojis Panel"
                className="buttonCloseEmojic p-overlaypanel-close p-link"
                onClick={onClosePanel}
            >
                <span className="pi pi-times" aria-hidden="true" />
            </button>
        </Panel>
    );
};

export default Emojis;
